/**
 * @generated SignedSource<<c695e3d54172e36b5976c3899e9481bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeType = "BOOLEAN" | "DATE" | "INTEGER" | "STRING" | "%future added value";
export type ContactAttributesPanelAttributeDefinitionsQuery$variables = Record<PropertyKey, never>;
export type ContactAttributesPanelAttributeDefinitionsQuery$data = {
  readonly attributeDefinitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityTypes: ReadonlyArray<string>;
        readonly id: string;
        readonly label: string;
        readonly name: string;
        readonly type: AttributeType;
      } | null | undefined;
    }>;
  };
};
export type ContactAttributesPanelAttributeDefinitionsQuery = {
  response: ContactAttributesPanelAttributeDefinitionsQuery$data;
  variables: ContactAttributesPanelAttributeDefinitionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "entityType",
        "value": "contact"
      }
    ],
    "concreteType": "AttributeDefinitionConnection",
    "kind": "LinkedField",
    "name": "attributeDefinitions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AttributeDefinitionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttributeDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "attributeDefinitions(entityType:\"contact\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactAttributesPanelAttributeDefinitionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContactAttributesPanelAttributeDefinitionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cb3e14bfb248bfb9595d92614f4dc935",
    "id": null,
    "metadata": {},
    "name": "ContactAttributesPanelAttributeDefinitionsQuery",
    "operationKind": "query",
    "text": "query ContactAttributesPanelAttributeDefinitionsQuery {\n  attributeDefinitions(entityType: \"contact\") {\n    edges {\n      node {\n        id\n        name\n        label\n        type\n        entityTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6fc6acfcfd1c8c5cbb3aa656c5c20cc";

export default node;
